import '../scss/main.scss';
import FormSender from './components/FormSender';

const firstInput = document.querySelector( '.form input' );
firstInput.focus();

const forms = document.querySelectorAll( 'form' ); 

forms.forEach( form => new FormSender( form, '/mail.php' ) );